<template>
    <div>
        <UtilsContent @close-action="closeSettings">
            <template v-slot:header>
                <div class="d-flex flex-row justify-start align-center mx-3 mb-4">
                    <img :src="settingImg" class="img-index mr-2" alt="" /><span
                        class="text-h5 ma-0 text--primary"
                        >{{ $t('bookReading.settings') }}</span
                    >
                </div>
            </template>
            <template v-slot:content>
                <div class="d-flex flex-column mx-3">
                    <v-row justify="start" align="start">
                        <v-col cols="12" class="d-flex flex-column justify-start align-start">
                            <span class="text--primary font-size-12">{{ $t('challenge.text_size') }}</span>
                            <div class="d-flex flex-row justify-start align-start mt-3">
                                <FontSizeSelector
                                    v-for="(size, index) of fontSizes"
                                    :key="index"
                                    :font_size="size"
                                    :active="fontSize === size"
                                    :isBookFunctionality="isBookFunctionality"
                                    :isChallengeFunctionality="isChallengeFunctionality"
                                >
                                    <span class="font-weight-light">{{ size }}p</span>
                                </FontSizeSelector>
                            </div>
                        </v-col>
                        <v-col cols="12" class="d-flex flex-column justify-start align-start">
                            <span class="text--primary font-size-12">{{ $t('challenge.font') }}</span>
                            <div class="d-flex flex-row justify-start align-start mt-3">
                                <FontFamilySelector
                                    v-for="(family, index) of fontFamilies"
                                    :key="index"
                                    :font_family="family"
                                    :active="fontFamily === family.fontFamilyId"
                                    :isBookFunctionality="isBookFunctionality"
                                    :isChallengeFunctionality="isChallengeFunctionality"
                                />
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </template>
        </UtilsContent>
    </div>
</template>
<script>
/* eslint-disable global-require */
import { mapState } from 'vuex'

import UtilsContent from './UtilsContent.vue'
import FontSizeSelector from './items/FontSizeSelector.vue'
import FontFamilySelector from './items/FontFamilySelector.vue'

export default {
    props: {
        isBookFunctionality: { type: Boolean, default: false },
        isChallengeFunctionality: { type: Boolean, default: false }
    },
    components: {
        UtilsContent,
        FontSizeSelector,
        FontFamilySelector,
    },
    computed: {
        ...mapState({
            bookReadConf: (state) => state.bookReading.bookReadConf,
            challengeConfig: (state) => state.challenge.config
        }),
        fontSize() {
            let result = this.bookReadConf && this.bookReadConf.fontSize
            if (this.isBookFunctionality) {
                return result
            }
            if (this.isChallengeFunctionality) {
                result = this.challengeConfig.fontSize
            }
            return result
        },
        fontFamily() {
            let result = this.bookReadConf && this.bookReadConf.fontFamily
            if (this.isBookFunctionality) {
                return result
            }
            if (this.isChallengeFunctionality) {
                result = this.challengeConfig.typography
            }
            return result
        }
    },
    data() {
        return {
            settingImg: require('@/assets/img/icons/reading/2-settings.svg'),
            fontSizes: ['22', '24', '28', '32', '36'],
            fontFamilies: [
                {
                    fontFamilyId: '0',
                    fontFamilyName: 'Report School',
                    fontFamilyValue: "'Poppins', sans-serif",
                },
                {
                    fontFamilyId: '1',
                    fontFamilyName: 'Roboto',
                    fontFamilyValue: "'Roboto', sans-serif",
                },
                {
                    fontFamilyId: '2',
                    fontFamilyName: 'Comic',
                    fontFamilyValue: "'Comic Sans MS', arial",
                },
                {
                    fontFamilyId: '3',
                    fontFamilyName: 'Fantasy',
                    fontFamilyValue: "'Arial', fantasy",
                },
            ],
        }
    },
    methods: {
        closeSettings() {
            this.$emit('close-settings')
        },
    },
}
</script>
<style>
.chapters-container {
    height: 35vh;
    max-height: 35vh;
    overflow: auto;
}
</style>
